import { allPhotos } from "./allPhotos";

export const anniversaryPhotos = allPhotos.filter(function(obj) { return obj.type.startsWith('Aniversário'); });